export default "__VITE_ASSET__CLbAANjV__"